import Api from 'App/api'

export const getListWithSettings = Api.get({
  controller: 'vehicles',
  action: 'listWithSettings',
})

export const deleteVehicle = Api.post({
  controller: 'vehicles',
  action: 'delete',
})

export const saveVehicle = Api.post({
  controller: 'vehicles',
  action: 'save',
})
